import React, { FC } from 'react'

import { FormikFormProps } from '../../../form/FormikForm'
import { FormSubmitButtonProps } from '../../../form/FormSubmitButton'
import FormikField from '../../../form/FormikField'
import { FormErrorsProps } from '../../../form/FormErrors'
import { CardProps } from '../../../Card'
import { FormFieldCheckboxProps } from '../../../form/fields/FormFieldCheckbox'

import * as SC from './styled'

export type AcceptTermsValues = {
  terms: boolean
}

export type AcceptTermsProps = {
  className?: string
  header: CardProps['header']
  content: {
    title: string
    formikForm: FormikFormProps<AcceptTermsValues>
    fields: {
      terms: FormFieldCheckboxProps
    }
    errors?: FormErrorsProps['errors']
    submitButton: FormSubmitButtonProps
  }
}

const AcceptTerms: FC<AcceptTermsProps> = ({
  className,
  header,
  content: { title, formikForm, fields, submitButton, errors },
}) => {
  return (
    <SC.BoxedContent>
      <SC.CardWrapper className={className} header={header}>
        <SC.Title>{title}</SC.Title>
        <SC.Form className={className} {...formikForm}>
          {({ isValid, dirty }) => (
            <>
              <SC.Fields>
                <FormikField {...fields.terms} Component={SC.FieldCheckBox} />
              </SC.Fields>
              {errors && <SC.Errors errors={errors} />}
              <SC.SubmitButton {...submitButton} disabled={!isValid || !dirty} />
            </>
          )}
        </SC.Form>
      </SC.CardWrapper>
    </SC.BoxedContent>
  )
}

export default AcceptTerms
